export const visit = (vm, at) => {
at({ "es": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "funci\xF3n disponible", "featureUnavailable": "funci\xF3n no disponible" } } } } });
};